const SavingMoneyChallenge2HintsText =
    ["You can use the savings calculator to determine which " +
        "items will result in the most savings",
     "Saving a small amount when a person is young usually leads to more " +
        "overall savings than saving a lot when a person is close to retirement."
    ]
   

export default SavingMoneyChallenge2HintsText;